import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import "../../../assets/css/steps.css";

const SIGNATURE_TYPES = {
  AUTOGRAPH: "AUTOGRAPH",
  DIGITAL: "DIGITAL",
};

const Step_4_Delegation = ({
  delegation = {},
  setDelegation = () => {},
  errors,
  setErrors,
}) => {
  const [signatureMethod, setSignatureMethod] = useState(
    delegation.signatureMethod || "",
  );

  const hasError = errors?.includes("signatureMethod");

  const removeFieldError = (field) => {
    if (errors.includes(field)) {
      const newErrors = errors.filter((e) => e !== field);
      setErrors(newErrors);
    }
  };

  const handleSignatureChange = (event) => {
    const value = event.target.value;
    removeFieldError("signatureMethod");
    setSignatureMethod(value);
    setDelegation({ ...delegation, signatureMethod: value });
  };

  const radioStyles = {
    color: "#5b5b5b",
    "&.Mui-checked": { color: "#5b5b5b" },
    "&:hover": { backgroundColor: "transparent" },
    "&:focus-visible": { outline: "none" },
  };

  const labelStyles = (hasError) => ({
    "& .MuiRadio-root + span": {
      color: hasError ? "#D32F2F" : "#5b5b5b",
      fontWeight: 400,
    },
  });

  return (
    <Grid container className="container-steps">
      <Grid item xs={12} sx={{ marginBottom: "50px" }}>
        <Typography className="title-steps">
          Seleziona la modalità di firma della delega
        </Typography>
        <Typography className="text-steps" style={{ marginTop: "10px" }}>
          Puoi scegliere tra due diverse modalità di firma:
        </Typography>

        <ul
          style={{ paddingLeft: "20px", marginTop: "10px", color: "#5b5b5b" }}
        >
          <li>
            <Typography className="text-steps" style={{ color: "#5b5b5b" }}>
              Firma <span style={{ fontWeight: "bold" }}>autografa</span>:
              accedi a una schermata dove potrai scaricare la delega. Ti basterà
              poi stamparla,{" "}
              <span style={{ fontWeight: "bold" }}>
                firmarla a penna e caricare una scansione
              </span>{" "}
              sul portale. <span style={{ fontWeight: "bold" }}></span>
            </Typography>
          </li>

          <li>
            <Typography className="text-steps" style={{ color: "#5b5b5b" }}>
              Firma <span style={{ fontWeight: "bold" }}>elettronica</span>:
              procedura{" "}
              <span style={{ fontWeight: "bold" }}>
                {" "}
                online, integrata sul portale
              </span>{" "}
              (non richiede stampa e scansione). La firma elettronica è
              rilasciata da un ente certificatore a livello europeo.{" "}
              <span style={{ fontWeight: "bold" }}></span>{" "}
            </Typography>
          </li>
        </ul>

        <Grid
          item
          xs={12}
          md={10}
          sx={{ backgroundColor: "#fffbb99d", p: "20px", mt: 2, mb: 2 }}
        >
          <Typography sx={{ fontSize: "18px !important", fontWeight: "bold" }}>
            Avviso sulla firma elettronica
          </Typography>
          <Typography className="text-steps" style={{ marginTop: "10px" }}>
            Per procedere con la firma elettronica sono richiesti i seguenti{" "}
            <span style={{ fontWeight: "bold" }}>requisiti</span>:
            <ul
              style={{
                paddingLeft: "20px",
                marginTop: "10px",
                color: "#5b5b5b",
              }}
            >
              <li>
                <Typography className="text-steps" style={{ color: "#5b5b5b" }}>
                  Immagini a colori, in alta qualità e senza ritagli di carta di
                  identità o passaporto (NO patente). Il documento di identità
                  non deve essere deteriorato in alcun modo e deve riportare gli
                  stessi dati inseriti in precedenza nella delega.
                  <span style={{ fontWeight: "bold" }}></span>
                </Typography>
              </li>

              <li>
                <Typography className="text-steps" style={{ color: "#5b5b5b" }}>
                  Telefono cellulare (già indicato in precedenza) attivo e
                  abilitato alla ricezione di sms. Il processo, infatti, prevede
                  l'invio di un codice OTP al tuo tefefono.
                  <span style={{ fontWeight: "bold" }}></span>{" "}
                </Typography>
              </li>
            </ul>
          </Typography>

          <Typography
            className="text-steps"
            style={{ color: "#5b5b5b", fontWeight: "bold" }}
          >
            In mancanza di anche uno solo dei requisiti, la firma elettronica
            non potrà essere apposta e il processo di delega verrà interrotto.
          </Typography>
          <Typography className="text-steps" style={{ color: "#5b5b5b" }}>
            Se non ti senti sicuro, ti suggeriamo di sceglierela modalità di
            firma autografa. Grazie.
          </Typography>
        </Grid>

        <RadioGroup
          row
          name="signatureType"
          value={signatureMethod}
          onChange={handleSignatureChange}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "4px",
            }}
          >
            <FormControlLabel
              value={SIGNATURE_TYPES.AUTOGRAPH}
              control={<Radio sx={radioStyles} />}
              label={
                <>
                  Firma <strong>autografa</strong>
                </>
              }
              sx={labelStyles(hasError)}
            />

            <FormControlLabel
              value={SIGNATURE_TYPES.DIGITAL}
              control={<Radio sx={radioStyles} />}
              label={
                <>
                  Firma <strong>elettronica</strong>
                </>
              }
              sx={labelStyles(hasError)}
            />
          </div>
        </RadioGroup>
      </Grid>
    </Grid>
  );
};

export default Step_4_Delegation;
